<template>
    <div>
        <b-row>
            <b-col sm="2">
                <InputNumber title="Federais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosFederais" />
            </b-col>
            <b-col sm="2">
                <InputNumber title="Estaduais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosEstaduais" />
            </b-col>
            <b-col sm="2">
                <InputNumber title="Municipais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosMunicipais" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";

import NfsePrefeitura from "./NfsePrefeitura.js";

import { mapActions } from "vuex";

export default {
    name: "Transparencia",
    props: ["disabled", "value"],
    components: {
        InputNumber,
    },
    data() {
        return {
            id: this.$route.params.id,
            transparencia: new NfsePrefeitura().transparencia,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            loading: false,
        }
    },
    mounted() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response && response.success) {
                    const data = response.content || {};
                    this.transparencia.percentualTotalTributosFederais = data.percentualTotalTributosFederais;
                    this.transparencia.percentualTotalTributosEstaduais = data.percentualTotalTributosEstaduais;
                    this.transparencia.percentualTotalTributosMunicipais = data.percentualTotalTributosMunicipais;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(value) {
                if (!value) return;
                if (value === this.transparencia) return;
                this.transparencia = {
                    ...this.transparencia,
                    ...value,
                };
            }
        },
        transparencia: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
}
</script>
